import React from 'react'

import { Checkbox, useFilter } from '@rewardops/ui'

import { handleEnterKeyPress } from '~/utils/event-handler-utils'
import DynamicScrollArea from '~/components/dynamic-scroll-area'

interface Brand {
  id: string
  name: string
  key: string
}

interface BrandsListFilterProps {
  brands: Brand[]
  onSelectionSet?: Function
}

export const BrandsListFilter = ({
  brands,
  onSelectionSet,
}: BrandsListFilterProps) => {
  const { selectedBrands, addToSelectedBrand } = useFilter()

  return (
    <DynamicScrollArea maxHeightClass="h-[20vh]" className="mb-5">
      <div className="flex flex-col gap-3">
        {brands?.map((brand) => (
          <div
            id={`brand-checkbox-${brand.id}`}
            key={brand.id}
            role="button"
            tabIndex={0}
            className="flex cursor-pointer items-center space-x-2 font-normal"
            onKeyDown={(e) => {
              handleEnterKeyPress(e, () => addToSelectedBrand(brand))

              if (onSelectionSet) onSelectionSet()
            }}
            onClick={(e) => {
              e.preventDefault()
              addToSelectedBrand(brand)

              if (onSelectionSet) onSelectionSet()
            }}
          >
            <Checkbox checked={selectedBrands?.includes(brand.key)} />
            <div className="cursor-pointer hover:text-tenant-primary-color">
              {brand.name}
            </div>
          </div>
        ))}
      </div>
    </DynamicScrollArea>
  )
}

export default BrandsListFilter
